<template>
  <div class="content-spacing-m">
    <div class="modelname" :class="{discontinued:ProjectorSpec[0].isMainPSConfig === 1&&selectedModelData.discontinued===true, 'modelname_without_nearModel':!isNearModelShow}">
      <span class="modeltitle">{{$t('T_MODEL_NAME')}}</span>
      <div class="search-projector-result_img">
        <el-image :src="pjImgUrl" :fit="fit"></el-image>
      </div>
      <div class="search-result">
        <span class="search-result-overflow" :title="selectedModel">{{ selectedModel }}</span>
        <ul>
          <li><span>{{$t('T_INFO_BRIGHTNESS')}}:</span>{{color}}{{$t('T_LUMEN')}}</li>
          <li v-if="brightnessByLens!='TBD' && brightnessByLens!='-'"><span>{{$t('T_INFO_BRIGHTNESS_REDUCED_BY_LENS')}}:</span>{{brightnessByLens}}{{$t('T_LUMEN')}}</li>
          <li><span>{{$t('T_INFO_RESOLUTION')}}:</span>{{resolution}}</li>
          <li><span>{{$t('T_INFO_WEIGHT')}}:</span>{{weight}}</li>
          <!-- 固定レンズ機種で投写比(Throw ratio)の表示追加 V2.3.2 -->
          <li v-if="selectedModelData.lensExchange == false"><span>{{$t('T_THROW_RATIO')}}:</span>{{throwRatio}}</li>
        </ul>
        <div class="info-dialog">
          <el-button class="projector-result_button" type="button" @click="centerDialogVisible = true">{{$t('T_SPEC_INFO')}}
          </el-button>
        </div>
      </div>
    </div>
    <div class="nearmodels" v-if="isNearModelShow">
      <el-row>
        <el-col :span="13">
            <span class="near-models ellipsis" :title="$t('T_NEAR_MODELS')">{{$t('T_NEAR_MODELS')}}</span>
          </el-col>
        <el-col :span="11"><span class="nearmodels-more ellipsis" :title="$t('T_MORE') + '>>'" @click="selectedModelAction" v-show="comparisonPJModelList.length > 0">{{$t('T_MORE')}}>></span></el-col>
      </el-row>
      <ul class="nearmodels-ul" v-show="comparisonPJModelList.length > 0">
        <li v-for="(item, index) in comparisonPJModelList" :key="index">
          {{item.name}}
        </li>
      </ul>
      <span class="no-result" v-show="comparisonPJModelList.length < 1">{{$t('T_NO_RESULT')}}</span>
    </div>
    <el-dialog title :visible.sync="centerDialogVisible" @close="onCloseInfoDialog" width="33%" center class="slot-title" :close-on-click-modal="false">
      <div slot="title">
        <div class="info">
          <span class="projector-title">{{$t('T_PROJECTOR_INFO')}}</span>
          <div class="dialog-img">
            <img :src="pjImgUrl" class="center-img" style="width: 118px;">
          </div>
          <p>{{selectedModel}}</p>
        </div>
      </div>
      <span>
        <el-tabs v-model="activeName" type="card" stretch>
          <el-tab-pane :label="$t('T_BASIC_SPEC')" name="first">
            <div class="pjDetailedInfo" v-for="(value, name, index) in mainSpecInfo" :key="index">
              <span v-if="name == 'POWER_CONSUMPTION_110'">{{ $t("T_INFO_POWER_CONSUMPTION") }} (100-110V) :</span>
              <span v-else-if="name == 'POWER_CONSUMPTION_220'">{{ $t("T_INFO_POWER_CONSUMPTION") }} (200-240V) :</span>
              <span v-else>{{ $t(name) }} :</span>
              <span v-if="value==='Laser Diode'">{{ $t('T_LIGHT_TYPE_LASER') }}</span>
              <span v-else-if="value==='Lamp'">{{ $t('T_LIGHT_TYPE_LAMP') }}</span>
              <span v-else>{{ value }}</span>
              <span v-if="name === 'T_INFO_BRIGHTNESS'">{{ $t('T_LUMEN') }}</span>
              <hr />
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('T_INTERFACE')" name="second">
            <div class="pjDetailedInfo" v-for="(value, name, index) in interfaceInfo" :key="index">
              <span>{{ $t(name) }} :</span>
              <span v-if="value">{{ value }}</span>
              <span v-else>{{ $t('T_NOTHING') }}</span>
              <hr />
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('T_FUNCTION')" name="third">
            <div class="pjDetailedInfo" v-for="(value, name, index) in functionInfo" :key="index">
              <span>{{ $t(name) }} :</span>
              <span v-if="value">{{ $t('T_YES') }}</span>
              <span v-else>{{ $t('T_NO') }}</span>
              <hr />
            </div>
          </el-tab-pane>
        </el-tabs>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">{{$t('T_OK')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="selectedModelDialogVisible" v-if="selectedModelDialogVisible" class="model-list" center :close-on-click-modal="false">
      <div class="info" slot="title">
        <div class="projector-title">{{$t('T_COMPATIBLE_MODEL_LIST')}}</div>
      </div>
      <comparisonModelTable @change="changeSelectModel" :list="comparisonPJModelList"></comparisonModelTable>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// import ProjectorSpec from '@/assets/data/projectorSpec.json'
// import Brightness from '@/assets/data/brightness.json'
import comparisonModelTable from '@/view/searchTabs/comparisonModelTable'

export default {
  name: 'searchProjectorResult',
  data () {
    return {
      centerDialogVisible: false,
      activeName: 'first',
      mainSpecInfo: this.bindMainInfo(),
      interfaceInfo: this.bindInterfaceInfo(),
      functionInfo: this.bindFunctionInfo(),
      selectedModel: this.$store.state.selectedModelData.name,
      fit: 'contain',
      comparisonPJModelList: [],
      selectedModelDialogVisible: false
    }
  },
  methods: {
    ...mapMutations([
      'SET_PJIMGTYPE',
      'F_S2D',
      'F_D2S',
      'F_VOFFSET',
      'VLENSSHIFT',
      'SET_TEMVLENSSHIFT',
      'HLENSSHIFT',
      'VHLENSSHIFT',
      'ASPECTRATIO',
      'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'MATCHINGLENSID', 'SELECTEDLENSDATA',
      'SEARCHMATCHINGMODELDATA', 'SEARCHSELECTEDMODELDATA', 'SEARCHMATCHINGLENSID', 'SEARCHSELECTEDLENSDATA',
      'BMMATCHINGMODELDATA', 'BMSELECTEDMODELDATA', 'BMMATCHINGLENSID', 'BMSELECTEDLENSDATA',
      'HTMMATCHINGMODELDATA', 'HTMSELECTEDMODELDATA', 'HTMSELECTEDLENSDATA', 'CATERADIO', 'CATEVALUE', 'SET_TEXTDATA'
    ]),
    onCloseInfoDialog () {
      this.activeName = 'first'
    },
    // 投影仪切换
    onModelChange (value) {
      this.setSelectedModelData(value)
      let lensData = this.findMatchingLensAndSelectedLensData(this.selectedModelData)
      this.setSelectedLensData(lensData)
    },
    setSelectedModelData (value) {
      let selectedModelData = value
      this.SELECTEDMODELDATA(value)
      if (this.searchTabActive === 'Search') {
        this.SEARCHSELECTEDMODELDATA(selectedModelData)
        this.SEARCHMATCHINGMODELDATA([selectedModelData])
        this.MATCHINGMODELDATA([selectedModelData])
      } else if (this.searchTabActive === 'Categolies') {
        let ratioVal = null
        let cate = null
        switch (this.selectedModelData.category) {
          case 0:
          case 1:
          case 2:
            cate = 0
            ratioVal = 'bm'
            break
          case 3:
          case 4:
            cate = 1
            ratioVal = 'bm'
            break
          case 6:
          case 7:
            cate = 2
            ratioVal = 'bm'
            break
          case 8:
            cate = 3
            ratioVal = 'bm'
            break
          case 9:
            cate = 4
            ratioVal = 'bm'
            break
          case 5:
            cate = 5
            ratioVal = 'htm'
            break
          default:
            break
        }
        let matchingModel = this.$commonJs.findMatchingModel(cate)
        this.MATCHINGMODELDATA(matchingModel)
        if (ratioVal === 'bm') {
          this.BMSELECTEDMODELDATA(selectedModelData)
          this.BMMATCHINGMODELDATA(matchingModel)

          this.CATERADIO('bmRadio')
          this.CATEVALUE(cate)
        } else {
          this.HTMSELECTEDMODELDATA(selectedModelData)
          this.HTMMATCHINGMODELDATA(matchingModel)

          this.CATERADIO('htmRadio')
        }
      }
    },

    setSelectedLensData (value) {
      this.MATCHINGLENSID(value.matchingLensID)
      this.SELECTEDLENSDATA(value.selectedLensInfo)
      if (this.searchTabActive === 'Search') {
        this.SEARCHMATCHINGLENSID(value.matchingLensID)
        this.SEARCHSELECTEDLENSDATA(value.selectedLensInfo)
      } else {
        if (this.cateRadio === 'bmRadio') {
          this.BMMATCHINGLENSID(value.matchingLensID)
          this.BMSELECTEDLENSDATA(value.selectedLensInfo)
        } else {
          this.HTMSELECTEDLENSDATA(value.selectedLensInfo)
        }
      }
    },
    bindMainInfo () {
      let data = JSON.parse(
        JSON.stringify(this.$store.state.selectedModelData)
      )
      let mainSpecData = {
        'T_INFO_BRIGHTNESS': data['color'],
        'T_INFO_CONTRAST': data['contrast'],
        'T_INFO_RESOLUTION': data['resolution'],
        'T_INFO_LIGHT_TYPE': data['lightType'],
        'T_INFO_WEIGHT': data['weightIncludingLens'],
        'T_INFO_SIZE': data['maxDimension'],
        'T_INFO_POWER_SUPPLY': data['supplyVoltage'],
        'POWER_CONSUMPTION_110': data['consumption100'] + ' (Normal) / ' + data['consumption100_eco'] + ' (Eco)',
        'POWER_CONSUMPTION_220': data['consumption220'] + ' (Normal) / ' + data['consumption220_eco'] + ' (Eco)',
        'T_INFO_FAN_NOISE': data['fanNoise']
      }

      return mainSpecData
    },
    bindInterfaceInfo () {
      let data = JSON.parse(
        JSON.stringify(this.$store.state.selectedModelData)
      )
      let interfaceData = {
        'T_INFO_RGB': data['inputRgb'],
        'T_INFO_HDMI': data['inputHdmi'],
        'T_INFO_VIDEO': data['inputVideo'],
        'T_INFO_USBA': data['inputUsbA'],
        'T_INFO_HDBASET': data['inputHdBaseT'],
        'T_INFO_WIRED_LAN': data['inputWiredLan'],
        'T_INFO_WIRELESS_LAN': data['inputWirelessLan']
      }
      return interfaceData
    },
    bindFunctionInfo () {
      let data = JSON.parse(
        JSON.stringify(this.$store.state.selectedModelData)
      )
      let functionData = {
        'T_INFO_PC_FREE': data['PCFREE'],
        'T_INFO_APP_FOR_PC': data['iProjectionForPC'],
        'T_INFO_APP_FOR_IOS': data['iProjectionForIOS'],
        'T_INFO_APP_FOR_ANDROID': data['iProjectionForAndroid']
      }
      return functionData
    },
    findMatchingLensAndSelectedLensData (model) {
      let selectedModelData = model
      let lensInfo = this.$commonJs.findLensInfo(selectedModelData)
      return lensInfo
    },
    setSpecificInfo (data) {
      let defaultRatio = data.lcd.aspectRatio
      let defaultDistInfo = data.lcd.distInfo.find(
        item => item.ratio === defaultRatio
      )
      this.F_S2D(defaultDistInfo.size2dist)
      this.F_D2S(defaultDistInfo.dist2size)
      this.F_VOFFSET(defaultDistInfo.screenSizeToVOffset)

      this.VLENSSHIFT(data.lcd.lensShiftRange.v)
      this.SET_TEMVLENSSHIFT(data.lcd.lensShiftRange.v)
      this.HLENSSHIFT(data.lcd.lensShiftRange.h)
      this.VHLENSSHIFT(data.lcd.lensShiftRange.hv)
      this.ASPECTRATIO(data.lcd.aspectRatio)
    },

    // 获取比较的机型
    findComparisonProjectorList () {
      this.comparisonPJModelList = []
      let lensData
      this.ProjectorSpec.map(pjItem => {
        if (pjItem.year >= 2016 && (this.ProjectorSpec[0].isMainPSConfig !== 1 || (this.ProjectorSpec[0].isMainPSConfig === 1 && pjItem.recommend))) {
          if (pjItem.lensExchange) {
            lensData = this.$commonJs.findLensDataByIdAndSize(pjItem.standardLens, pjItem.lcdSize)
          } else {
            lensData = this.$commonJs.findLensDataByHCode(pjItem.code)
          }
          if (!lensData) {
            console.log('findComparisonProjectorList error') // TODO
            return
          }

          let distInfoData = lensData.lcd.distInfo
          let lensShiftRange = lensData.lcd.lensShiftRange
          for (let i = 0; i < distInfoData.length; i++) {
            let _screenSize = distInfoData[i].screenSize
            let screenSizeRange = {
              min: _screenSize.w.min,
              max: _screenSize.t.max ? _screenSize.t.max : _screenSize.w.max
            }
            if (this.screenSize >= screenSizeRange.min && this.screenSize <= screenSizeRange.max) {
              let size2dist = distInfoData[i].size2dist
              let throwRange = this.getThrowDistanceRange(size2dist)
              if (this.graph.pjY >= Math.floor(throwRange.min) && this.graph.pjY <= throwRange.max) {
                let flag = 'Not Available'
                for (let key in lensShiftRange) {
                  if (lensShiftRange[key].max !== 0 || lensShiftRange[key].min !== 0) {
                    flag = 'Available'
                  }
                }
                if (pjItem.name !== this.selectedModel) {
                  this.comparisonPJModelList.push({
                    ...pjItem,
                    brightness: pjItem.color,
                    resolution: pjItem.resolution,
                    lensShiftAvailable: flag
                  })
                  break
                }
              }
            }
          }
        }
      })
      this.comparisonPJModelList = this.$commonJs.dataSort(this.comparisonPJModelList, 'name')
    },

    getThrowDistanceRange (size2dist) {
      let size2distW = size2dist.w
      let size2distT = size2dist.t
      let screenSize = this.screenSize
      let throwDistanceMin = size2distW.a * screenSize + size2distW.b
      let throwDistanceMax = size2distT ? size2distT.a * screenSize + size2distT.b : size2distW.a * screenSize +
      size2distW.b
      let throwDistanceRange = {
        min: throwDistanceMin,
        max: throwDistanceMax
      }
      return throwDistanceRange
    },

    changeSelectModel (data) {
      this.onModelChange(data)
      this.selectedModelDialogVisible = false
    },

    selectedModelAction () {
      if (!this.comparisonPJModelList || this.comparisonPJModelList.length < 1) {
        this.$message('No Near Model')
      } else {
        this.selectedModelDialogVisible = true
      }
    }
  },

  watch: {
    selectedModelData (val, oldVal) {
      this.selectedModel = val.name
      this.mainSpecInfo = this.bindMainInfo()
      this.interfaceInfo = this.bindInterfaceInfo()
      this.functionInfo = this.bindFunctionInfo()
      this.SET_PJIMGTYPE(this.selectedModelData.type)
      this.findComparisonProjectorList()
    },

    screenSize () {
      this.findComparisonProjectorList()
    }
  },
  computed: {
    ...mapState(['searchTabActive', 'cateRadio', 'screenSize', 'graph', 'selectedModelData', 'matchingModelData', 'selectedLensData', 'cateValue', 'searchTabActive']),

    white () {
      return this.selectedModelData.whiteNormal
    },
    color () {
      return this.selectedModelData.color
    },
    brightnessByLens () {
      if (this.selectedModelData.lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        let pjName = this.selectedModelData.name
        let brightArr = []
        if (pjName.indexOf('Pro') !== -1) {
          this.Brightness.optionLens.forEach(item => {
            if (item.code === code && item.lensId === lensId) {
              brightArr.push(item)
            }
          })
          if (brightArr && brightArr.length === 2) {
            return brightArr.find(item => item.EAI === true).brightness
          } else {
            return brightArr[0].brightness
          }
        }

        return this.Brightness.optionLens.find(item => item.code === code && item.lensId === lensId && item.EAI === false).brightness
      }
      return '-'
    },
    resolution () {
      return this.selectedModelData.resolution
    },
    weight () {
      return this.selectedModelData.weightIncludingLens
    },
    // 固定レンズ機種で投写比(Throw ratio)の表示追加 V2.3.2 
    throwRatio () {
      return this.selectedLensData.throwRatio
    },
    pjImgUrl () {
      let url = this.selectedModelData.url
      return url + '.jpg'
    },
    isNearModelShow () {
      return this.searchTabActive !== 'Blending' && this.searchTabActive !== 'Specification' && this.searchTabActive !== 'InstallCondition'
    }
  },
  mounted () {
    this.findComparisonProjectorList()
  },
  components: {
    comparisonModelTable
  }
}
</script>

<style scoped>
.info img {
  width: 25%;
}

.pjDetailedInfo {
  text-align: left;
}

.pjDetailedInfo span {
  height: 36px;
  line-height: 36px;
  text-align: left;
}

.slot-title >>> .el-dialog {
  min-width: 440px;
}

.info-dialog {
  float: left;
}

.content-spacing-m {
  height: 207px;
  background: #fff;
  margin-right: 10px;
  border: 1px solid #bdbdbd;
}

.modelname {
  float:left;
  width:405px;
  height: 205px;
}
.modelname_without_nearModel{
  width:auto;

}

.nearmodels {
  float:left;
  height: 100%;
  width: calc(100% - 405px);
  position: relative;
  line-height: 1.2;
  border-left: 1px solid #cccccc;
}

.modelname .modeltitle,
.nearmodels span {
  display: block;
  padding: 15px 10px;
  font-weight:bold;
  font-size:16px;
}

.search-result {
  display: inline-block;
  width: calc(100% - 137px);
}

.search-result-overflow {
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-result > span {
  font-weight: bold;
}

.search-result ul {
  color:#999999;
  font-size:14px;
  line-height: 1.5;
  margin: 2px 0 3px;
  white-space: nowrap;
  letter-spacing: -0.05px;
  overflow: auto;
}

.search-result li span{
  font-weight: bold;
  color: #000;
  padding-right: 5px;
}

.nearmodels-ul {
  font-size: 14px;
  font-weight: bold;
  padding: 0 10px;
  height: calc(100% - 50px);
  overflow: auto;
}

.nearmodels-ul li {
  list-style: none;
  padding: 7px 0;
  border-top: 1px solid #e3e3e3;
  color: #999;
}

.nearmodels-ul li:last-child {
  border-bottom: 1px solid #e3e3e3;
}

.nearmodels-more {
  text-align: right;
  color: #003298;
  cursor: pointer;
}

.no-result {
  font-weight: normal;
  color: #999999;
}

.dialog-img {
  position: relative;
}

.search-result li .brightness-unit{
  font-weight: normal;
  color: #999
}

.center-img {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.near-models {
  width: 135px;
}

.discontinued {
  background: #DCDFE6
}
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/searchProjectorResult.vue